// @flow
import * as React from 'react';
import Box from 'sail/Box';
import './UseCaseGuideCards.scss';

type UseCaseGuideCardsProps = {|
  children: React.Node,
|};

export const UseCaseGuideCards = ({children}: UseCaseGuideCardsProps) => {
  return (
    <Box
      margin={{
        top: 16,
      }}
      className="UseCaseGuideCards"
    >
      {children}
    </Box>
  );
};
